import eav from '@/components/tools/eav'

export default {
  setUpdating (state, value) {
    state.updating = value
  },
  setWaitingForCallingUpdate (state, value) {
    state.waitingForCallingUpdate = value
  },

  setProductTypeOptionIds (state, data) {
    state.productTypeOptionIds = data
  },

  setProduct (state, data) {
    state.product = data

    if (state.product?.damages?.length > 0) {
      const sortOrder = state.product?.damages?.map(d => d.sortOrder)
      let i = 0
      let needsFixing = false
      sortOrder.forEach((s) => {
        if (s !== i) {
          needsFixing = true
        }
        i++
      })
      if (needsFixing) {
        for (let i = 0; i < state.product?.damages?.length; i++) {
          console.log(i)
          state.product.damages[i].sortOrder = i
        }
      }
    }
  },

  setProductsSubmittedCount (state, data) {
    state.productsSubmittedCount = data
  },

  setVersionedProduct (state, data) {
    state.versionedProduct = data
  },

  setOwner (state, data) {
    state.owner = data
  },

  prepareProductForUpload (state) {
    const data = state.product
    state.product.attributes.datetimes = eav.prepareDatetimesForUpload(data.attributes.datetimes)

    state.product.attributes.ints = eav.prepareNumbersForUpload(data.attributes.ints, true)
    state.product.attributes.decimals = eav.prepareNumbersForUpload(data.attributes.decimals)
  },

  prepareVersionedProductForUpload (state) {
    const data = state.versionedProduct
    state.versionedProduct.attributes.datetimes = eav.prepareDatetimesForUpload(data.attributes.datetimes)

    state.versionedProduct.attributes.ints = eav.prepareNumbersForUpload(data.attributes.ints, true)
    state.versionedProduct.attributes.decimals = eav.prepareNumbersForUpload(data.attributes.decimals)
  },

  setLoggingPayload (state, {
    source,
    attributeCode,
    value
  }) {
    state.product.updateLoggingPayload = {
      source,
      attributeCode,
      value: JSON.stringify(value)
    }
  },

  setEmptyDamageDto (state, damageDto) {
    state.emptyDamageDto = damageDto
  },

  setAttributes (state, data) {
    state.attributes = data
  },
  setAttributesDe (state, data) {
    state.attributesDe = data
  },

  setSimpleAttribute (state, {
    attributeCode,
    value
  }) {
    state.product[attributeCode] = value
  },

  setAttribute (state, {
    attributeCode,
    value
  }) {
    eav.setEavAttribute(attributeCode, value, state.product.attributes, state.attributes)
  },

  unsetAttribute (state, attributeCode) {
    eav.unsetEavAttribute(attributeCode, state.product.attributes, state.attributes)
  },

  setVersionedProductAttribute (state, {
    attributeCode,
    value
  }) {
    eav.setEavAttribute(attributeCode, value, state.versionedProduct.attributes, state.attributes)
  },

  setBooleanAttribute (state, {
    attributeCode,
    value
  }) {
    eav.setEavAttribute(attributeCode, value, state.product.attributes, state.attributes)
  },

  setProductDatetimes (state, { datetimes }) {
    state.product.attributes.datetimes = datetimes
  },

  setGallery (state, { gallery }) {
    state.product.gallery = gallery
  },

  setVersionedProductGallery (state, { gallery }) {
    state.versionedProduct.gallery = gallery
  },

  setAuctionDatetimes (state, { datetimes }) {
    state.product.auction.attributes.datetimes = datetimes
  },

  setSimpleAuctionAttribute (state, {
    attributeCode,
    value
  }) {
    state.product.auction[attributeCode] = value
  },

  updateDamages (state, {
    sortOrder,
    attributeCode,
    value
  }) {
    if (sortOrder === state.product.damages.length) {
      const damageDto = Object.assign({}, state.emptyDamageDto)
      damageDto.sortOrder = sortOrder
      eav.setEavAttribute(attributeCode, value, damageDto.attributes, state.attributes)
      state.product.damages.push(damageDto)

      return
    }

    const damageDto = state.product.damages.find(damage => damage.sortOrder === sortOrder)

    if (attributeCode === 'damage_area' || attributeCode === 'trailer_damage_area') {
      damageDto.attributes.selects = []
    }

    eav.setEavAttribute(attributeCode, value, damageDto.attributes, state.attributes)
  },

  removeDamageImage (state, { sortOrder }) {
    // const found = state.product.damages.find(g => g.sortOrder === sortOrder)
    const found = state.product.damages[sortOrder]
    if (found) {
      state.product.damages.splice(found.sortOrder, 1)
    }

    state.product.damages.forEach((g, i) => {
      g.sortOrder = i
    })
  },

  removeAllDamageImages (state) {
    state.product.damages = []
  },

  addToGallery (state, image) {
    state.product.gallery.push(image)
  },

  addToVersionedProductGallery (state, image) {
    state.versionedProduct.gallery.push(image)
  },

  updateGalleryImage (state, {
    index,
    value
  }) {
    state.product.gallery.splice(index, 1, value)
  },

  updateVersionedProductGalleryImage (state, {
    index,
    value
  }) {
    state.versionedProduct.gallery.splice(index, 1, value)
  },

  removeGalleryImage (state, index) {
    state.product.gallery = state.product.gallery.filter((_, imageIndex) => imageIndex !== index)
  },

  removeVersionedProductGalleryImage (state, index) {
    state.versionedProduct.gallery = state.versionedProduct.gallery.filter((_, imageIndex) => imageIndex !== index)
  },

  removeLastGalleryImage (state) {
    state.product.gallery.pop()
  },
  removeLastGalleryImages (state, count) {
    for (let i = 0; i < count; i++) {
      state.product.gallery.pop()
    }
  },

  removeLastVersionedProductGalleryImages (state, count) {
    for (let i = 0; i < count; i++) {
      state.versionedProduct.gallery.pop()
    }
  },

  setEditing (state, component) {
    state.editing = component
  },

  setPanels (state, value) {
    state.panels = value
  },
  setPanelsEquipment (state, value) {
    state.panelsEquipment = value
  },
  setPanelsImages (state, value) {
    state.panelsImages = value
  },

  setProgressControlClass (state, value) {
    state.progressControlClass = value
  },

  setOverlay (state, value) {
    state.overlay = value
  },

  closePanels (state) {
    state.panels = []
  },

  closePanel (state, idx) {
    const found = state.panels.indexOf(idx)

    if (found > -1) {
      state.panels.splice(found, 1)
    }
  },

  closePanelEquipment (state, idx) {
    const found = state.panelsEquipment.indexOf(idx)

    if (found > -1) {
      state.panelsEquipment.splice(found, 1)
    }
  },

  updateGallery (state, array) {
    const gallery = []
    for (let i = 0; i < array.length; i++) {
      gallery.push({
        value: array[i].value,
        position: i
      })
    }

    state.product.gallery = gallery
  },

  updateVersionedProductGallery (state, array) {
    const gallery = []
    for (let i = 0; i < array.length; i++) {
      gallery.push({
        value: array[i].value,
        position: i
      })
    }

    state.versionedProduct.gallery = gallery
  },

  setDefectsDescriptionValid (state, value) {
    state.defectsDescriptionValid = value
  },

  setUploadingGalleryImages (state, value) {
    state.uploadingGalleryImages = value
  }

}
